module.exports = __webpack_public_path__ + "static/flags/SY-7452dae0afe22435618b599074e23775.gif";